import ControlOptions from "slotworks/smart-ui/options/control-options";
import AbstractNumberInputControl from "../abstract/abstract-number-input-control";

export default class CustomLossLimitInputControl extends AbstractNumberInputControl {

    public updateOptions(options: ControlOptions) {
        const limitValues = options.getValidLossLimits();

        if (!this.setupData) {

            if (!limitValues || limitValues.length === 0) {
                this.setEnabled(false);
            } else {
                if (limitValues[0] !== 0) {
                    limitValues.unshift(0);
                }

                this.setMinMaxRange(limitValues[0], limitValues[limitValues.length - 1]);

                this.input.setDefaults(this.min.toString());
            }

            this.setupData = true;
        }

        if (options.customLossLimitSelected && limitValues && limitValues.length > 0) {
            this.input.setVisible(true);
            this.input.focus();

            if (options.lossLimit.currentValue > 0) {
                this.resetValue();
            }

        } else {
            this.input.setVisible(false);
        }

        super.updateOptions(options);
    }

    protected onChangeHandler() {
        const value = this.getValidatedCurrency();

        if (value >= 0) {
            const options = new ControlOptions();

            options.lossLimit.currentValue = value;
            options.customLossLimitSelected = false;

            this.onChange.dispatch(options);
        } else {
            this.input.setText("");
        }
    }

    private resetValue() {
        this.input.setText("");
    }
}
